import * as React from "react"

export default function useMedia(queries, values, defaultValue) {
  const queriesRef = React.useRef(queries)
  const valuesRef = React.useRef(values)
  queriesRef.current = queries
  valuesRef.current = values

  const getValue = React.useCallback(() => {
    const index = queriesRef.current.findIndex((query) => window.matchMedia(query).matches)
    return typeof valuesRef.current[index] !== "undefined" ? valuesRef.current[index] : defaultValue
  }, [defaultValue])

  // The server and the browser's first render must use the same value. Once
  // hydration has finished, synchronize it with the actual viewport.
  const [value, setValue] = React.useState(defaultValue)

  React.useEffect(() => {
    const mediaQueryLists = queriesRef.current.map((query) => window.matchMedia(query))
    const handler = () => setValue(getValue)
    const subscribe = (mediaQueryList) => {
      if (mediaQueryList.addEventListener) mediaQueryList.addEventListener("change", handler)
      else mediaQueryList.addListener(handler)
    }
    const unsubscribe = (mediaQueryList) => {
      if (mediaQueryList.removeEventListener) mediaQueryList.removeEventListener("change", handler)
      else mediaQueryList.removeListener(handler)
    }

    handler()
    mediaQueryLists.forEach(subscribe)

    return () => mediaQueryLists.forEach(unsubscribe)
  }, [getValue])

  return value
}
